import React from "react";

export const MyAuction = () => {
  return (
    <div>
      <h1>MyAuction</h1>
    </div>
  );
};
